<nz-page-header class="site-page-header">
  <nz-breadcrumb nz-page-header-breadcrumb>
    <nz-breadcrumb-item>
      <a routerLink="../..">
        <i nz-icon nzType="home"></i>
      </a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>Usuários</nz-breadcrumb-item>
  </nz-breadcrumb>

  <nz-page-header-title>Usuários</nz-page-header-title>

  <nz-page-header-extra>
    <button nz-button nzType="primary" (click)="openFilterModal()">
      <i nz-icon nzType="filter" nzTheme="fill"></i>
      Filtrar
    </button>
  </nz-page-header-extra>
</nz-page-header>

<div class="px-4">
  <div *ngIf="numberOfActiveFilters > 0" class="active-filters mb-4 flex items-center space-x-2">
    <nz-badge class="active-filters-badge">
      <small>{{ numberOfActiveFilters }} filtro(s) ativo(s):</small>
    </nz-badge>

    <app-active-filters
      [filters]="filters"
      (removeClick)="removeIndividualFilter($event)"
      data-testid="active-filters"></app-active-filters>

    <button class="filter-actions" nz-button nzSize="small" (click)="clearFilters()">Limpar filtros</button>
  </div>

  <nz-table #usersTable [nzData]="users" nzShowPagination nzShowSizeChanger [nzPageIndex]="page" (nzPageIndexChange)="changePage($event)">
    <thead>
      <tr>
        <th>ID</th>
        <th>Nome</th>
        <th>Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of usersTable.data">
        <td>
          {{ user._id }}
        </td>
        <td>{{ user.firstName }} {{ user.lastName }}</td>
        <td>
          <button nz-button [nzType]="'primary'" [routerLink]="[user._id]"><span>Detalhes</span></button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
